import { Link } from "react-router";
import { Button } from "@/components/ui/button.tsx";
import { AlertCircle, LoaderCircle, Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { getTickets } from "@/api/support/getTickets.ts";
import { SupportTicket } from "@/types/supportTicket.ts";
import { setTitle } from "@/hooks/useHeader.ts";
import SupportTicketCard from "@/components/SupportTicketCard.tsx";
import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert.tsx";
import { useTranslation } from "@/i18n";

const Support = () => {
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState<SupportTicket[]>();
  const [error, setError] = useState<string>();
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(t("support.title"));
    (async () => {
      try {
        const response = await getTickets();
        setTickets(response.data);
      } catch (e: unknown) {
        setError(t("support.fetchFailed"));
      }
      setLoading(false);
    })();
  }, [t]);

  return (
    <div className="relative mx-auto flex h-full max-w-md min-w-[45vw] flex-col gap-2 p-4">
      <Link to="/support/create-ticket" className="self-end">
        <Button size="lg">
          <Plus />
          {t("support.createTicket")}
        </Button>
      </Link>
      <ScrollArea className="size-full overflow-auto">
        <div className="flex h-full w-full flex-col items-center gap-4">
          {loading && <LoaderCircle className="size-6 animate-spin" />}
          {!loading && !tickets?.length && <div>{t("support.empty")}</div>}
          {!!error && (
            <Alert variant="destructive" className="mx-auto my-4 w-fit">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>{t("common.somethingWentWrong")}</AlertTitle>
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          {!!tickets?.length &&
            tickets.map((ticket) => (
              <SupportTicketCard ticket={ticket} key={ticket.id} />
            ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default Support;
